module.exports = __webpack_public_path__ + "static/media/1382_old.0c89136b.jpg";